<div class="switch-container">
    <button 
        *ngFor="let btn of buttons" 
        [class]="btn.selected ? 'btn active' : 'btn'"
        (click)="onClick(btn)">
        <div class="content">
            <span>{{btn.title}}</span>
        </div>
    </button>
</div>